import { Social } from '@shared/interfaces/account/social.interface';
import { Achievements } from '@shared/interfaces/profile/achievements.interface';
import { BasicProjectsInfo } from '@shared/interfaces/profile/basic_projects_info.interface';
import { BasicEventsInfo } from '@shared/interfaces/profile/basic_events_info.interface';

export class User {
  avatar_image: string;
  birthday: string | any;
  created_at: string;
  deleted_at: string;
  email: string;
  facebook_id: string;
  googleplus_id: string;
  tax_residence: string | any;
  language: number | any;
  has_email_change_request: boolean;
  id: number | string;
  is_active: number;
  name: string;
  day: string;
  month: string;
  year: string;
  roles: string[];
  updated_at: string;
  user_settings: any;
  username: string;
  kyc_lvl: string;
  fv_status: string;
  fv_message: string | null;
  kyc_seen: boolean;
  showBanner: boolean;
  type: string;
  surname: string;
  sign_project_by_name: boolean;
  profile_description: string;
  origin_country: string | any;
  nickname: string;
  social_links: Social[];
  display_name: string;
  continent: string;
  settings: {
    mail_notifications: boolean;
    payment_terms: boolean;
    payout_terms: boolean;
  };
  achievements: Achievements[];
  basic_projects_info: BasicProjectsInfo = {
    active: 0,
    closed: 0,
    in_verification: 0,
    donated: 0,
  };
  basic_events_info: BasicEventsInfo = {
    active: 0,
    closed: 0,
    draft: 0,
  };

  constructor(data?: any) {
    Object.assign(this, data);
  }
}
